import {BaseFilterHelper} from "src/app/_modules/analytics/common/utils/filter/base-filter-helper";
import {CombinedOrderElementDto} from "../../../models/core/combined-order-element-dto";

export class PerformanceTrackerFilterHelper  extends BaseFilterHelper{
  constructor() {
    super();
  }

  applyFilter(combinedOrderElements: CombinedOrderElementDto[], cachedCombinedOrderElements: CombinedOrderElementDto[]): void {
    combinedOrderElements.splice(0, combinedOrderElements.length + cachedCombinedOrderElements.length, ...combinedOrderElements.concat(cachedCombinedOrderElements) );
    cachedCombinedOrderElements.splice(0, cachedCombinedOrderElements.length);

    for(let filter of this.filter){
      let i = 0;
      let len = combinedOrderElements.length;
      while(i<len)
      {
        // check if element needs to be filtered out

        // @ts-ignore
        if(combinedOrderElements[i][filter.key as string]=== filter.value){
          cachedCombinedOrderElements.push(combinedOrderElements[i]);
          combinedOrderElements.splice(i, 1);
          len--;
        }
        else {
          i++;
        }
      }
    }

  }
}
